export default "__VITE_ASSET__sEEU1x$I__"